import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css'
import helper from "../common/Helper";

const MAP_STYLES = {
    roadmap: "mapbox://styles/mapbox/streets-v11", // Default road map
    satellite: "mapbox://styles/mapbox/satellite-v9", // Satellite map
    terrain: "mapbox://styles/mapbox/outdoors-v11", // Terrain map
    hybrid: "mapbox://styles/mapbox/satellite-streets-v11" // Hybrid (satellite + labels)
};

const MapboxNew = ({ lat, lng, zoom, mapLoaded , mapType = "terrain" }) => {
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null); // Store the map instance
    

    useEffect(() => {
        if (!mapLoaded || !lat || mapInstanceRef.current) return;
        mapboxgl.accessToken = helper.mapboxAccessToken;
        // console.log(lat);
        

        const myLatLng = { lat: lat, lng: lng };
        const coordinatesMap = [lng, lat];

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            // style: 'mapbox://styles/toursxplorer/cl1n9jjk500s514o39rqwrk6v',
            style: MAP_STYLES[mapType] || MAP_STYLES.roadmap, // Use the selected map style
            center: myLatLng,
            zoom: zoom
        });
        mapInstanceRef.current = map;
        // Add navigation controls
        map.addControl(new mapboxgl.NavigationControl());

        // Add a GeoJSON source and layer
        map.on('load', () => {
            map.addSource('source_id', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'Point',
                                coordinates: coordinatesMap
                            }
                        }
                    ]
                }
            });

            map.addLayer({
                id: 'points',
                source: 'source_id',
                type: 'circle',
                paint: {
                    'circle-radius': 50,
                    'circle-color': 'rgba(227, 189, 62, 1)',
                    'circle-opacity': 0.3,
                    'circle-stroke-width': 4,
                    'circle-stroke-color': 'rgba(227, 189, 62, 1)'

                }
            });
        });

        return () => {
            // Don't remove the map, just hide it in the parent component
        };
    }, [mapLoaded]);

    return <div ref={mapContainerRef} style={{ width: "100%", height: "50vh" }} />;

}
export default MapboxNew;